/**
 * Parses FAQ pairs from free-form HTML (admin editPages field).
 * Expects pairs of <h3>Question</h3><p>Answer</p>.
 * Strips all HTML tags from content — returns plain text only.
 *
 * @param {string} html - Raw HTML from store.couponPageDescription
 * @returns {Array<{ question: string, answer: string }>}
 */
export default function parseFaqFromHtml(html) {
  if (!html || typeof html !== 'string') return [];

  try {
    const pairs = [];
    const regex = /<h3[^>]*>(.*?)<\/h3>\s*<p[^>]*>(.*?)<\/p>/gis;
    let match;

    while ((match = regex.exec(html)) !== null) {
      const question = match[1].replace(/<[^>]+>/g, '').trim();
      const answer = match[2].replace(/<[^>]+>/g, '').trim();

      if (question && answer) {
        pairs.push({ question, answer });
      }
    }

    return pairs;
  } catch {
    return [];
  }
}
